import React from "react";
import { Link } from "react-router-dom";

function Breadcrump(props) {
  return (
    <div>
      <div class="breadcrumb-area">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="breadcrumb-wrap">
                <nav aria-label="breadcrumb">
                  <ul class="breadcrumb">
                    <li class="breadcrumb-item">
                      <Link to="/">
                        <i class="fa fa-home"></i>
                      </Link>
                    </li>
                    <li class={props.class1} aria-current="page">
                      {props.cont1}
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      {props.cont2}
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Breadcrump;
